export function isNativeCapacitorRuntime() {
  try {
    return !!(typeof window !== "undefined" && (window.Capacitor?.isNativePlatform?.() || window.location?.protocol === "capacitor:" || window.location?.protocol === "ionic:"));
  } catch (_) {
    return false;
  }
}

export function platformAsset({ web, native, fallback = "" } = {}) {
  return isNativeCapacitorRuntime() ? (native || web || fallback || "") : (web || native || fallback || "");
}

export function getNativeSafeAsset(src = "") {
  const raw = String(src || "");
  if (!raw) return "";
  if (!isNativeCapacitorRuntime()) return raw;
  const [path, query = ""] = raw.split("?");
  if (!path.toLowerCase().endsWith(".webp")) return raw;
  const nativeExt = path.includes("/blue-heeler-sync") || path.includes("/notification-mail") ? ".gif" : ".png";
  const nativePath = `/native-assets${path.replace(/\.webp$/i, nativeExt)}`;
  return query ? `${nativePath}?${query}` : nativePath;
}

export const SYNC_RUNNING_DOG_ICON_WEB = "/icons/web/blue-heeler-sync.gif";
export const SYNC_RUNNING_DOG_ICON_NATIVE = "/icons/native/blue-heeler-sync.gif";
export const SYNC_RUNNING_DOG_ICON_NATIVE_FALLBACK = "/icons/native/blue-heeler-sync.gif";
export const SYNC_RUNNING_DOG_SPRITE_WEB = "/icons/shared/blue-heeler-sync-sprite.png";
export const SYNC_RUNNING_DOG_SPRITE_NATIVE = "/native-assets/icons/shared/blue-heeler-sync-sprite.png";
export const NOTIFICATION_MAIL_ICON_WEB = "/icons/web/notification-mail.webp";
export const NOTIFICATION_MAIL_ICON_NATIVE = "/icons/native/notification-mail.gif";

export function getSyncRunningDogIcon() {
  return platformAsset({ web: SYNC_RUNNING_DOG_ICON_WEB, native: SYNC_RUNNING_DOG_ICON_NATIVE, fallback: SYNC_RUNNING_DOG_ICON_NATIVE_FALLBACK });
}

export function getSyncRunningDogSprite() {
  return platformAsset({ web: SYNC_RUNNING_DOG_SPRITE_WEB, native: SYNC_RUNNING_DOG_SPRITE_NATIVE, fallback: SYNC_RUNNING_DOG_SPRITE_WEB });
}

export function getNotificationMailIcon() {
  return platformAsset({ web: NOTIFICATION_MAIL_ICON_WEB, native: NOTIFICATION_MAIL_ICON_NATIVE, fallback: "" });
}
